import Head from 'next/head';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { getAllResources, Resource } from ':src/utils/getResources';
import StyledNextLink from ':src/components/StyledNextLink';

export type ResourcesPageProps = {
  resources: Resource[];
};

export const getStaticProps: GetStaticProps<ResourcesPageProps> = async () => {
  return {
    props: { resources: await getAllResources() },
  };
};

export default function ResourcesPage({ resources }: ResourcesPageProps) {
  const router = useRouter();
  const pageURL = `${process.env.DOMAIN!}${router.asPath}`;
  return (
    <>
      <Head>
        <title>Resources | frontendeval</title>
        <meta
          name="description"
          content="Blog posts and content to help you understand the interview process better"
        />
        <meta property="og:title" content="Resources | frontendeval" />
        <meta
          property="og:description"
          content="Blog posts and content to help you understand the interview process better"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageURL} />
      </Head>
      <div className="container py-12">
        <h1 className="text-4xl mb-12">Resources</h1>
        {resources.map(({ title, description, slug }) => (
          <div className="mb-8">
            <h2 className="mb-2 text-xl">
              <StyledNextLink href={`/resources/${slug}`}>
                {title}
              </StyledNextLink>
            </h2>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </>
  );
}
